'use client';

import type { ReactNode } from 'react';

interface FormErrorBoxProps {
  children: ReactNode;
  /**
   * `alert` for the step-level summary, so screen readers announce it when it
   * appears. Field-level boxes are referenced by the input's
   * `aria-describedby` instead and should stay silent to avoid double reading.
   */
  role?: 'alert';
  id?: string;
}

/**
 * The filled error box used for both the step summary and per-field messages.
 * Sits *above* what it refers to, per the design.
 */
export const FormErrorBox = ({ children, role, id }: FormErrorBoxProps) => (
  <div
    id={id}
    role={role}
    className="rounded-input bg-[#f7dfe3] px-6 py-4 text-sm text-[#b3243b]"
  >
    {children}
  </div>
);
